export const GetInvestmentBuyList = `/Inv_RequestCustomer/GetInvestmentBuyList`;

// export const InvestmentPortfolioBuy = `/Inv_RequestCustomer/InvestmentPortfolioBuy`;

export const GetInvestmentPortfolioCancel = (id) =>
  `/Inv_RequestCustomer/GetInvestmentPortfolioCancel?Id=${id}`;

export const GetInvestmentFixedCancel = (id) =>
  `/Inv_RequestCustomer/GetInvestmentFixedCancel?Id=${id}`;

export const GetInvestmentFixedClose = (id) =>
  `/Inv_RequestCustomer/GetInvestmentFixedClose?Id=${id}`;

export const InvestmentPortfolioCancel =
  "/Inv_RequestCustomer/InvestmentPortfolioCancel";

export const InvestmentFixedCancel =
  "/Inv_RequestCustomer/InvestmentFixedCancel";

export const GetInvestmentPortfolioCurrentlyList = `/Inv_RequestCustomer/GetInvestmentPortfolioCurrentlyList`;

export const GetInvestmentFixedCurrentlyList = `/Inv_RequestCustomer/getInvestmentFixedCurrentlyList`;

export const InvestmentPortfolioClose = `/Inv_RequestCustomer/InvestmentPortfolioClose`;

export const InvestmentFixedClose = `/Inv_RequestCustomer/InvestmentFixedClose`;

export const GetInvestmentPortfolioCurrentlyInfo = `/Inv_RequestCustomer/GetInvestmentPortfolioCurrentlyInfo`;

export const GetInvestmentFixedCurrentlyInfo = `/Inv_RequestCustomer/GetInvestmentFixedCurrentlyInfo`;

export const InvestmentPortfolioBuy = `/Inv_RequestCustomer/InvestmentPortfolioBuy`;

export const GetInvestmentPortfolioClose = (id) =>
  `/Inv_RequestCustomer/GetInvestmentPortfolioClose?Id=${id}`;

export const GetInvestmentPortfolioBuyAmountMax = (id) =>
  `/Inv_RequestCustomer/GetInvestmentPortfolioBuyAmountMax?Id=${id}`;

export const GetInvestmentPortfolioHistoryForm = `/Inv_RequestCustomer/GetInvestmentPortfolioHistoryForm`;

export const GetInvestmentPortfolioHistoryList = ({
  portfolioId,
  startDateInvestmentStart,
  endDateInvestmentStart,
  startDateInvestmentEnd,
  pageNumber,
  pageSize,
}) =>
  `/Inv_RequestCustomer/GetInvestmentPortfolioHistoryList?PortfolioId=${portfolioId || -1
  }&StartDateInvestmentStart=${startDateInvestmentStart || ""
  }&EndDateInvestmentStart=${endDateInvestmentStart || ""
  }&StartDateInvestmentEnd=${startDateInvestmentEnd || ""}&PageNumber=${pageNumber || 1
  }&PageSize=${pageSize || 20}`;

export const GetInvestmentPortfolioRequestHistoryForm = `/Inv_RequestCustomer/GetInvestmentPortfolioRequestHistoryForm`;

export const CheckInvestmentRulesConfirmation = `/Inv_RequestCustomer/CheckInvestmentRulesConfirmation`;

export const GetPortfolioChartList = (id) => `/Inv_RequestCustomer/GetPortfolioChartList?Id=${id}`;

export const GetInvestmentPortfolioRequestHistoryList = ({ portfolioId, sideId, coinId, startDate, endDate, pageNumber, pageSize }) =>
  `/Inv_RequestCustomer/GetInvestmentPortfolioRequestHistoryList?PortfolioId=${portfolioId || -1
  }&SideId=${sideId || 0
  }&CoinId=${coinId || -1
  }&StartDate=${startDate || ""
  }&EndDate=${endDate || ""
  }&PageNumber=${pageNumber || 1
  }&PageSize=${pageSize || 20}`;


export const GetUnitTradeChartList = (id) => `/Inv_RequestCustomer/GetUnitTradeChartList?Id=${id}`;

export const GetPortfolioChartPartialList = ({ id, coin, startDate, endDate }) => `/Inv_RequestCustomer/GetPortfolioChartPartialList?Id=${id || 0
  }&Coin=${coin || "Main"
  }&StartDateTime=${startDate || ""
  }&EndDateTime=${endDate || ""
  }`;